module.exports = __webpack_public_path__ + "static/img/product-estimate.90f5ca85.png";